/**
 * Identity
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchUsersResponseItem } from './search-users-response-item';

export interface SearchUsersResponseItemPagedList {
  totalCount?: number;
  items?: Array<SearchUsersResponseItem> | null;
}
